import { DialogueReplyIcon, IClientConfigs, RewardType } from '~/shared';
import { INotificationsService } from '../NotificationsService';
import { AbstractDialogueService } from './AbstractDialogueService';

export class DialogueServiceStub extends AbstractDialogueService {
	private readonly testDialogueConfig: IClientConfigs['quests']['dialogues'] = [
		{
			id: 'test-1',
			title: 'Bob Bebson',
			text: 'Повседневная практика показывает, что укрепление и развитие структуры в значительной степени обуславливает создание системы обучения кадров, соответствует насущным потребностям. Идейные соображения высшего порядка, а также рамки и место обучения кадров требуют от нас анализа соответствующий условий активизации. Повседневная практика показывает, что новая модель организационной деятельности обеспечивает широкому кругу (специалистов) участие в формировании модели развития.',
			replies: [
				{
					text: 'Привет!',
					icon: DialogueReplyIcon.NEXT,
					actions: [{ name: 'next', params: ['test-2'] }],
				},
				{
					text: 'Показывай задание',
					icon: DialogueReplyIcon.QUEST,
					actions: [{ name: 'next', params: ['test-3'] }],
				},
				{
					text: 'Пока',
					icon: DialogueReplyIcon.EXIT,
					actions: [{ name: 'exit', params: [] }],
				},
				{
					text: 'Типа вот без иконки',
					icon: DialogueReplyIcon.NONE,
					actions: [{ name: 'pepe', params: ['farm_quest_start'] }],
				},
			],
			reward: [],
			conditions: [],
			npcId: 'test-1',
			isInitial: true,
		},
		{
			id: 'test-2',
			title: 'Bob Bebson',
			text: 'Как дела?',
			replies: [
				{
					text: 'Назад',
					icon: DialogueReplyIcon.NEXT,
					actions: [{ name: 'next', params: ['test-1'] }],
				},
				{
					text: 'Вперед',
					icon: DialogueReplyIcon.NEXT,
					actions: [{ name: 'next', params: ['test-3'] }],
				},
			],
			reward: [],
			conditions: [],
			npcId: 'test-1',
			isInitial: true,
		},
		{
			id: 'test-3',
			title: 'Bob Bebson',
			text: 'Идейные соображения высшего порядка, а также сложившаяся структура организации в значительной степени обуславливает создание форм развития. Товарищи! новая модель организационной деятельности обеспечивает широкому кругу (специалистов) участие в формировании систем массового участия',
			replies: [
				{
					text: 'Взять задание',
					icon: DialogueReplyIcon.QUEST,
					actions: [{ name: 'quest', params: ['farm_quest_start'] }],
				},
				{
					text: 'В начало',
					icon: DialogueReplyIcon.NEXT,
					actions: [{ name: 'next', params: ['test-1'] }],
				},
			],
			reward: [
				[RewardType.EXP, '10000'],
				[RewardType.MONEY, '10000'],
			],
			conditions: [],
			npcId: 'test-1',
			isInitial: true,
		},
	];

	constructor(notifications: INotificationsService) {
		super(notifications);

		this.onAction('quest', (event?: string) => {
			console.log(`quest: ${event}`);
		});

		this.onAction('next', (dialogueId?: string) => {
			if (!dialogueId) {
				console.error(
					`Action "next" requires dialogueId, but got ${dialogueId}`,
				);
				return;
			}

			this.dialogueId.next(dialogueId);
		});

		this.dialogueId.next('test-1');
	}

	protected getConfig(): IClientConfigs['quests']['dialogues'] {
		return this.testDialogueConfig;
	}

	public override async selectReply(replyId: string): Promise<void> {
		super.selectReply(replyId);
		console.log('Selected reply:', replyId);
	}
}
